const useDomain = () => {
  if (window.location.hostname.match(/.skytrakgolf|localhost/)) {
    return 'skytrak';
  }

  return 'clubhouse';
};

export default useDomain;
